import { HttpClient } from '@angular/common/http';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import {
    TfCartType,
    TfCartAddResponseType,
    TfCartLineItemType,
    TfCartProductType,
    TfProductAttributesType
} from '@app/modules/tf-cart';
import { CookieService } from 'ngx-cookie-service';
import { TfBlockUIService } from '@app/modules/tf-block-ui';
import { TfNotificationsService } from '@app/modules/tf-notifications';
import { TfUserDataService } from '@app/modules/tf-user-data';
import { TfWindowRefService } from "@app/modules/tf-window-ref";

@Injectable({
  providedIn: 'root'
})

export class TfCartService {
    constructor(private httpClient: HttpClient,
              private cookieService: CookieService,
              private tfBlockUIService: TfBlockUIService,
              private window: TfWindowRefService,
              private tfNotificationsService: TfNotificationsService,
              private userDataSrv: TfUserDataService)
    { }

    addToCart(cart: TfCartType) : Observable<TfCartAddResponseType> {
        this.tfBlockUIService.start();

        return this.httpClient.post<any>(`/api/store/carts/addToCart`, cart).pipe(
            tap(response => ({
                cardId: response?.data?.cartId,
                lineItems: [
                  {
                    lineNo: response?.data?.lineItems[0]?.lineNo,
                    product: response?.data?.lineItems[0]?.product,
                    quantity: response?.data?.lineItems[0]?.quantity,
                  }
                ]
            })),
            finalize(()=>{
                this.tfBlockUIService.stop();
            }),
            catchError(err => {
                console.error(err);
                return throwError(err);
            }),
        );
    }

    getItems(id, row, type = "assay"): TfCartLineItemType[] {
        let quantity = 1;
        let price = row.price;

        if (row.qty) {
            quantity = parseInt(row.qty, 10);
            price = quantity * price;
        }

        return [{
          "lineNo": "",
          "parentLineNo": "",
          "price": price?.toString(),
          "quantity": quantity?.toString(),
          "product": <TfCartProductType>{
              "sku": type === "assay" ? row.catalogNumber : id,
              "productAttributes": <TfProductAttributesType>{
                  "id": id
              }
          }
        }];
    }

    addToCartSubscriber(cart) {
        this.addToCart(cart).subscribe({
            next: (res) => {
                const miniCart = this.getGlobalCart();

                if (miniCart) {
                    try {
                        miniCart.initiateAddItem();
                        const itemsCount = cart.lineItems.length;
                        miniCart.showCart({
                            addToCart: true,
                            params: {
                                count: itemsCount,
                                recentItemsShowCount: itemsCount > 2 ? 2 : 1
                            }
                        });
                        miniCart.updateItemCountInHeader();
                    } catch (e) {
                        this.tfNotificationsService.showSuccessHtml(res['message'], "", { toastClass: 'availability-notification',timeOut: 5000, extendedTimeOut: 5000 } );
                    }

                } else {
                    this.tfNotificationsService.showSuccessHtml("Items have been added to the cart", "Success", { toastClass: 'availability-notification',timeOut: 5000000, extendedTimeOut: 5000000 } );
                }
            },
            error: () => {
                this.tfNotificationsService.showErrorHtml("Unexpected error adding items to cart. Please try again later", "Error adding to cart", { toastClass: 'availability-notification',timeOut: 10000, extendedTimeOut: 10000 } );
            }
        });
    }

    getCart(lineItems): TfCartType {
        return {
            cartId: this.getCartId().toString(),
            cartName: "Cart",
            countryCode: this.userDataSrv.getCountryCode(),
            languageCode: this.userDataSrv.getLanguageCode(),
            lineItems: lineItems
        };
    }

    getCartId() {
        return parseInt(this.cookieService.get("cartId"));
    }

    getGlobalCart() {
        return this.window.nativeWindow.miniCart;
    }
}
